<template>
  <div class="info-items">
    <div class="detail-item" :class="item.class" v-for="item in items" :key="item.prop">
      <div class="label" :style="{ flex: `0 0 ${labelWdith}px` }">{{ item.label }}：</div>
      <div class="value">{{ info[item.prop] }}</div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
import UploadFileList from "@/views/components/upload-file-list";
export default {
  name: "info-items",
  props: {
    items: Array,
    info: Object,
    labelWdith: {
      default: "120",
    },
  },
  data() {
    return {};
  },
  methods: {},
  components: { UploadFileList },
};
</script>
<style scoped lang="scss">
.info-items {
  display: flex;
  flex-wrap: wrap;
}
.detail-item {
  width: 50%;
  padding: 10px;
  display: flex;
  box-sizing: border-box;
  min-width: 300px;
  &.full-width {
    flex: 0 0 100%;
  }

  .label {
    padding: 6px 12px 6px 0;
    box-sizing: border-box;
    text-align: right;
  }
  .value {
    flex: 1;
    line-height: 1.5;
    min-height: 36px;
    padding: 6px 12px;
    color: #333;
    box-sizing: border-box;
    background: #fbfbfb;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    word-break: break-all;
  }
}
</style>
